import RaffleAncolService from "service/RaffleAncol";

/**
 * Fetch all raffle rewards with pagination
 */
export const getAllRaffleAncol =
  (page: number = 1, search: string = "", limit: number = 10) =>
  async (dispatch: any) => {
    try {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: true });
      const response = await RaffleAncolService.getAllRaffleAncol(
        page,
        search,
        limit
      );
      dispatch({
        type: "GET_ALL_RAFFLE_ANCOL",
        payload: response.raffles,
      });
      dispatch({
        type: "SET_RAFFLE_ANCOL_PAGINATION",
        payload: {
          currentPage: response.current_page,
          totalPage: response.last_page,
          limitPage: limit,
          lengthPage: response.total_data,
        },
      });
    } catch (error) {
      console.error("Error fetching raffle ancol:", error);
    } finally {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: false });
    }
  };

/**
 * Get single raffle reward by ID
 */
export const getRaffleAncolDetail =
  (raffleId: string) => async (dispatch: any) => {
    try {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: true });
      const response = await RaffleAncolService.getRaffleAncolDetail(raffleId);
      dispatch({
        type: "SET_RAFFLE_ANCOL_DETAIL",
        payload: response,
      });
    } catch (error) {
      console.error("Error fetching raffle detail:", error);
    } finally {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: false });
    }
  };

/**
 * Store new raffle reward
 */
export const storeRaffleAncol =
  (payload: any, callback?: () => void) => async (dispatch: any) => {
    try {
      dispatch({ type: "SET_RAFFLE_ANCOL_FORM_LOADING", payload: true });
      const response = await RaffleAncolService.storeRaffleAncol(payload);

      dispatch({
        type: "ADD_RAFFLE_ANCOL",
        payload: response,
      });

      if (callback) {
        setTimeout(() => {
          callback();
        }, 500);
      }

      alert("Raffle reward berhasil ditambahkan!");
    } catch (error) {
      console.error("Error storing raffle ancol:", error);
      alert("Gagal menambahkan raffle reward");
    } finally {
      dispatch({ type: "SET_RAFFLE_ANCOL_FORM_LOADING", payload: false });
    }
  };

/**
 * Update raffle reward
 */
export const updateRaffleAncol =
  (raffleId: string, payload: any, callback?: () => void) =>
  async (dispatch: any) => {
    try {
      dispatch({ type: "SET_RAFFLE_ANCOL_FORM_LOADING", payload: true });
      const response = await RaffleAncolService.updateRaffleAncol(
        raffleId,
        payload
      );

      dispatch({
        type: "UPDATE_RAFFLE_ANCOL",
        payload: response,
      });

      if (callback) {
        setTimeout(() => {
          callback();
        }, 500);
      }

      alert("Raffle reward berhasil diupdate!");
    } catch (error) {
      console.error("Error updating raffle ancol:", error);
      alert("Gagal mengupdate raffle reward");
    } finally {
      dispatch({ type: "SET_RAFFLE_ANCOL_FORM_LOADING", payload: false });
    }
  };

/**
 * Delete raffle reward
 */
export const deleteRaffleAncol =
  (raffleId: string, callback?: () => void) => async (dispatch: any) => {
    try {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: true });
      await RaffleAncolService.deleteRaffleAncol(raffleId);

      dispatch({
        type: "DELETE_RAFFLE_ANCOL",
        payload: raffleId,
      });

      if (callback) {
        setTimeout(() => {
          callback();
        }, 500);
      }

      alert("Raffle reward berhasil dihapus!");
    } catch (error) {
      console.error("Error deleting raffle ancol:", error);
      alert("Gagal menghapus raffle reward");
    } finally {
      dispatch({ type: "SET_RAFFLE_ANCOL_LOADING", payload: false });
    }
  };
